import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18 8H16L16 6C16 4.34 17.34 3 19 3C20.66 3 22 4.34 22 6V7C22 7.55229 22.4477 8 23 8C23.5523 8 24 7.55229 24 7V6C24 3.24 21.76 1 19 1C16.24 1 14 3.24 14 6V8H9H7H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM6 20H18V10H6V20Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.065 4.50006C10.065 3.70753 10.7075 3.06506 11.5 3.06506H12.5C13.2925 3.06506 13.935 3.70753 13.935 4.50006V5.50006C13.935 5.8121 14.188 6.06506 14.5 6.06506C14.812 6.06506 15.065 5.8121 15.065 5.50006V4.50006C15.065 3.08345 13.9166 1.93506 12.5 1.93506H11.5C10.0834 1.93506 8.935 3.08345 8.935 4.50006V5.93506H4.5C3.63567 5.93506 2.935 6.63573 2.935 7.50006V12.5001C2.935 13.3644 3.63567 14.0651 4.5 14.0651H11.5C12.3643 14.0651 13.065 13.3644 13.065 12.5001V7.50006C13.065 6.63573 12.3643 5.93506 11.5 5.93506H10.065V4.50006ZM9.5 7.06506H4.5C4.25975 7.06506 4.065 7.25981 4.065 7.50006V12.5001C4.065 12.7403 4.25975 12.9351 4.5 12.9351H11.5C11.7402 12.9351 11.935 12.7403 11.935 12.5001V7.50006C11.935 7.25981 11.7402 7.06506 11.5 7.06506H9.5Z"
  />
);

export const UnlockIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Unlock" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
